module.exports = __webpack_public_path__ + "img/dt-default-logo.378a6b0f.png";